var _circle, _circle2, _circle3, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaCard3Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343 629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 343,
    height: 629,
    fill: "currentColor",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 124,
    x2: 100,
    y2: 165,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 124,
    x2: 245,
    y2: 165,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 145,
    r: 6,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 145,
    r: 6,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 193,
    cy: 145,
    r: 6,
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m266,152.4l3.66-14.4h6.1c2.86,0,4.68,1.81,4.68,4.18,0,2.22-1.57,4.07-3.97,4.86l1.57,5.37h-4.18l-1.27-4.98h-1.38l-1.27,4.98h-3.93Zm5.97-8.03h2.3c1.25,0,2.15-.93,2.15-2,0-.78-.54-1.3-1.28-1.3h-2.34l-.84,3.29Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.93,152.4l2.82-11.11h-3.86l.84-3.29h11.7l-.84,3.29h-3.86l-2.82,11.11h-3.97Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.71,152.4l3.64-14.4h3.8l3.11,8.44,2.03-8.44h3.86l-3.64,14.4h-3.8l-3.13-8.44-1.98,8.44h-3.89Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 309,
    height: 595,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 124,
    x2: 327,
    y2: 124,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 166,
    x2: 327,
    y2: 166,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 366,
    x2: 327,
    y2: 366,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 506,
    x2: 327,
    y2: 506,
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169,491.82c-61.21,0-111-24.49-111-54.59s49.8-54.59,111-54.59c.26,0,.51,0,.76,0,.12,0,.25,0,.37,0,.36,0,.73,0,1.09.01,60.17.58,108.78,24.84,108.78,54.58s-48.59,53.99-108.78,54.58c-.36,0-.72.01-1.09.01-.12,0-.25,0-.37,0-.26,0-.51,0-.76,0Zm-23.38-5.9c-47.35-5.02-82.82-24.94-82.82-48.69s35.47-43.67,82.82-48.69c-17.62,9.03-29.72,27.46-29.72,48.69s12.1,39.66,29.72,48.69Zm49.67-.33c45.89-5.51,79.92-25.1,79.92-48.36s-34.03-42.85-79.92-48.36c17.28,9.14,29.09,27.39,29.09,48.36s-11.81,39.22-29.09,48.36Zm-39.61-96.31c-10.22,3.12-19.06,9.46-25.35,17.83,3.14,2.14,6.83,3.92,10.91,5.37,1.17-3.93,2.62-7.57,4.33-10.84,2.81-5.35,6.21-9.49,10.11-12.36Zm12.19-.23c-10.88,1.21-18.42,11.43-22.39,24.77,6.9,1.93,14.61,2.98,22.39,3.15v-27.92Zm-27.74,27.62c-4.67-1.61-8.83-3.61-12.27-5.94-4.5,7.23-7.22,15.69-7.53,24.75h17.5c.14-6.6.93-12.96,2.31-18.81Zm2.08,18.81c.14-5.98.87-11.94,2.16-17.49,7.09,1.97,15.12,3.12,23.49,3.29v14.2h-25.66Zm-4.39,4.38h-17.46c.47,8.99,3.3,17.36,7.89,24.5,3.45-2.29,7.46-4.19,11.86-5.73-1.37-5.84-2.15-12.18-2.29-18.77Zm6.54,17.44c-1.29-5.54-2.01-11.48-2.15-17.44h25.66v14.13c-8.15.17-16.23,1.27-23.51,3.32Zm-3.12,5.58c-3.89,1.37-7.43,3.05-10.46,5.05,5.86,7.57,13.83,13.41,23.01,16.62-3.12-2.74-5.88-6.37-8.23-10.84-1.71-3.26-3.16-6.9-4.33-10.83Zm26.63,23.42c-10.88-1.21-18.41-11.42-22.39-24.76,6.89-1.92,14.6-2.97,22.39-3.14v27.89Zm26.7-84.66c-2.83-5.39-6.26-9.56-10.2-12.42,10.29,3.08,19.21,9.42,25.54,17.83-3.15,2.16-6.89,3.98-11.01,5.43-1.17-3.93-2.62-7.57-4.33-10.84Zm-22.31-12.59c10.89,1.21,18.42,11.43,22.4,24.77-6.9,1.93-14.61,2.99-22.4,3.15v-27.92Zm25.66,46.43c-.14-5.99-.87-11.95-2.17-17.5-7.09,1.97-15.11,3.12-23.5,3.29v14.21h25.66Zm2.08-18.82c1.38,5.85,2.17,12.21,2.31,18.82h17.65c-.31-9.1-3.05-17.58-7.58-24.83-3.47,2.36-7.66,4.38-12.38,6.01Zm-27.74,23.2h25.67c-.14,6.14-.85,12.03-2.1,17.45-7.29-2.05-15.4-3.16-23.57-3.33v-14.13Zm30.05,0c-.14,6.59-.93,12.93-2.29,18.77,4.44,1.55,8.5,3.48,11.97,5.8,4.62-7.15,7.47-15.54,7.94-24.57h-17.61Zm-30.05,18.55c7.81.16,15.54,1.22,22.45,3.15-1.09,3.68-2.44,7.08-4.03,10.12-3.28,6.25-9.07,13.62-18.42,14.62v-27.9Zm22.31,15.3c-2.37,4.52-5.16,8.17-8.32,10.93,9.26-3.18,17.3-9.04,23.21-16.64-3.06-2.03-6.63-3.73-10.56-5.12-1.17,3.93-2.62,7.57-4.32,10.83Z",
    style: {
      fill: "#0e0e0e",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.11,100.07c-17.5,0-30.23-13.32-30.23-31.59s12.72-31.59,30.23-31.59c14.86,0,26.64,9.73,27.84,23.05l-8.37.68c-1.11-9.39-9.31-16.31-19.47-16.31-12.55,0-21.69,10.25-21.69,24.16s9.14,24.08,21.69,24.08c10.25,0,18.61-7.26,19.72-17.08l8.28.68c-1.2,13.83-13.06,23.91-28.01,23.91h0Zm66.18,0c-17.42,0-30.14-13.23-30.14-31.59s12.72-31.59,30.14-31.59,30.23,13.23,30.23,31.59-12.81,31.59-30.23,31.59h0Zm-21.6-31.59c0,13.92,9.14,24.08,21.6,24.08s21.6-10.16,21.6-24.08-9.05-24.16-21.6-24.16-21.6,10.16-21.6,24.16h0Zm61.34,29.88v-59.77h8.71l32.53,46.96-.34-46.96h8.28v59.77h-8.71l-32.53-46.96.34,46.96h-8.28Zm76.67,0v-52.6h-19.38v-7.17h47.3v7.17h-19.38v52.6h-8.54Z",
    style: {
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(41 222.18)",
    style: {
      fontFamily: "StabilGroteskVariable-Regular, &apos",
      fontSize: 19,
      fontVariationSettings: "&apos",
      opacity: 0.99
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K")), /*#__PURE__*/React.createElement("tspan", {
    x: 12.98,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.48,
    y: 0,
    style: {
      letterSpacing: "-.02em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.24,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.39,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "l"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 55.48,
    y: 0
  }, "e")), /*#__PURE__*/React.createElement("tspan", {
    x: 66.37,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "d"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 77.84,
    y: 0
  }, "ge shari")), /*#__PURE__*/React.createElement("tspan", {
    x: 144.95,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "n"), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 155.46,
    y: 0
  }, "g ")), /*#__PURE__*/React.createElement("tspan", {
    x: 170.9,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "c"), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 181.73,
    y: 0
  }, "o")), /*#__PURE__*/React.createElement("tspan", {
    x: 192.92,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 203.16,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 210.1,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 220.95,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "n"), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 231.19,
    y: 0
  }, "t ")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.73,
    y: 22.8,
    style: {
      letterSpacing: "-.02em"
    }
  }, "r"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 13.34,
    y: 22.8
  }, "om ")), /*#__PURE__*/React.createElement("tspan", {
    x: 45.12,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.13,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.31,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.81,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.66,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "r"), _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 91.5,
    y: 22.8
  }, "s a")), /*#__PURE__*/React.createElement("tspan", {
    x: 114.61,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 125.11,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "d "), /*#__PURE__*/React.createElement("tspan", {
    x: 140.37,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 147.1,
    y: 22.8,
    style: {
      letterSpacing: "-.02em"
    }
  }, "r"), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 153.71,
    y: 22.8
  }, "om ")), /*#__PURE__*/React.createElement("tspan", {
    x: 185.49,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 192.68,
    y: 22.8,
    style: {
      letterSpacing: "0em"
    }
  }, "h"), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 203.18,
    y: 22.8
  }, "e ")), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 45.6,
    style: {
      letterSpacing: "0em"
    }
  }, "c"), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 10.83,
    y: 45.6
  }, "ommuni")), /*#__PURE__*/React.createElement("tspan", {
    x: 80.46,
    y: 45.6,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 87.65,
    y: 45.6
  }, "y itse")), /*#__PURE__*/React.createElement("tspan", {
    x: 133.66,
    y: 45.6,
    style: {
      letterSpacing: "-.04em"
    }
  }, "l"), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 138.2,
    y: 45.6
  }, "f ")), /*#__PURE__*/React.createElement("tspan", {
    x: 148.81,
    y: 45.6,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 155.74,
    y: 45.6
  }, "o be ")), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 68.4
  }, "sha")), /*#__PURE__*/React.createElement("tspan", {
    x: 29.77,
    y: 68.4,
    style: {
      letterSpacing: "-.02em"
    }
  }, "r"), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 36.44,
    y: 68.4
  }, "ed wi")), /*#__PURE__*/React.createElement("tspan", {
    x: 82.74,
    y: 68.4,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 89.93,
    y: 68.4
  }, "h ")), /*#__PURE__*/React.createElement("tspan", {
    x: 104.23,
    y: 68.4,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 111.41,
    y: 68.4,
    style: {
      letterSpacing: "0em"
    }
  }, "h"), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 121.92,
    y: 68.4
  }, "e ")), /*#__PURE__*/React.createElement("tspan", {
    x: 136.63,
    y: 68.4,
    style: {
      letterSpacing: "0em"
    }
  }, "c"), _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 147.46,
    y: 68.4
  }, "ommuni")), /*#__PURE__*/React.createElement("tspan", {
    x: 217.09,
    y: 68.4,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 224.27,
    y: 68.4
  }, "y ")), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 91.2
  }, "a")), /*#__PURE__*/React.createElement("tspan", {
    x: 9.84,
    y: 91.2,
    style: {
      letterSpacing: "0em"
    }
  }, "n"), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 20.35,
    y: 91.2
  }, "d ")), /*#__PURE__*/React.createElement("tspan", {
    x: 35.61,
    y: 91.2,
    style: {
      letterSpacing: "0em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.79,
    y: 91.2,
    style: {
      letterSpacing: "0em"
    }
  }, "h"), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 53.29,
    y: 91.2
  }, "e ")), /*#__PURE__*/React.createElement("tspan", {
    x: 68,
    y: 91.2,
    style: {
      letterSpacing: "-.02em"
    }
  }, "w"), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 83.67,
    y: 91.2
  }, "o")), /*#__PURE__*/React.createElement("tspan", {
    x: 94.87,
    y: 91.2,
    style: {
      letterSpacing: "0em"
    }
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 101.86,
    y: 91.2,
    style: {
      letterSpacing: "0em"
    }
  }, "l"), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 106.95,
    y: 91.2
  }, "d."))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.25 151.46)",
    style: {
      fontFamily: "StabilGrotesk-BlackItalic, &apos",
      fontSize: 19,
      fontStyle: "italic",
      fontWeight: 800
    }
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "03"))), /*#__PURE__*/React.createElement("path", {
    d: "m95.56,594.49v-1.55l4.74-.39,1.84-1.26,15.86-63.24-1.84-1.26-4.64-.39v-1.55h34.33v17.5h-1.84l-4.25-15.09h-14.99l-7.45,29.98h7.93l9.77-1.35h1.74v5.42h-1.74l-9.77-1.45h-8.61l-8.03,32.2h17.12l10.44-16.83h1.74l-6.19,19.24h-36.17Zm78.05,0l-11.51-62.66-14.51,59.47,2.51,1.26,6.09.39v1.55h-18.08v-1.55l4.74-.39,1.84-1.26,15.96-63.82-6.19-1.26v-1.35h13.15l11.41,63.05,14.7-59.86-2.42-1.26-6.09-.39v-1.55h18.08v1.55l-4.74.39-1.84,1.26-16.63,66.43h-6.48Zm26.94,0v-1.55l5.9-.39,2.32-1.26,15.86-64.11-10.83-.77-9.86,17.99h-1.93l6.29-20.21h1.64l4.35.68h26.79l4.74-.68h1.64l-.68,20.21h-1.74l-3.48-17.89-10.35.58-15.76,64.21,2.32,1.26,5.8.39v1.55h-23.02Z",
    style: {
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaCard3Mobile);
export default __webpack_public_path__ + "static/media/media-card-3-mobile.ed64192e5cdcc2c8d23032ab89be2f72.svg";
export { ForwardRef as ReactComponent };